import styled, { css } from 'vue-styled-components';

import { GRAY } from '@/styles/common.styled';
import { ITEM_STATUS } from '../styles';

export const ComponentWrapper = styled.div`
    display: grid;
    gap: 15px;
`;

export const OptionWrapper = styled.div`
    height: 56px;
    background-color: ${GRAY(10)};
    display: flex;
    justify-content: space-between;
`;

export const SettingWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 12px 16px;
    color: ${GRAY(100)};
    border: 1px solid ${GRAY(20)};

    h1 {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 107px;
        font-size: 13px;
        color: ${GRAY(100)};
    }
`;

export const SelectedBoxWrapper = styled.div`
    width: 100%;
    position: relative;
    cursor: pointer;

    .selected-box > h1 {
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
`;

export const DropdownBoxWrapper = styled.div`
    width: 100%;
    position: absolute;
    z-index: 1;
    margin-top: 3px;
`;

export const StatusSelectedBoxWrapper = styled(SelectedBoxWrapper, {
    status: String,
})`
    .selected-box {
        ${({ status }) =>
            status === ITEM_STATUS.INVALID &&
            css`
                background-color: var(--color-gray-20);

                h1 {
                    color: var(--color-gray-50);
                }
            `}
    }
`;
